"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WfStatusOptions = exports.CountryCodes = exports.PriceDescriptionTypes = exports.UrlServiceTypes = exports.SingleDateStatus = void 0;
// Note that status "normal" is not explicitly encoded here.
// An empty field is considered "normal".
exports.SingleDateStatus = [
    { value: "cancelled", label: "Geannuleerd" },
    { value: "soldout", label: "Uitverkocht" },
    { value: "movedto", label: "Verplaatst naar" },
    { value: "premiere", label: "Première" },
    { value: "reprise", label: "Reprise" },
];
exports.UrlServiceTypes = [
    { value: "general", label: "urlServiceType.general" },
    { value: "booking", label: "urlServiceType.booking" },
    { value: "review", label: "urlServiceType.review" },
    { value: "video", label: "urlServiceType.video" },
    { value: "webshop", label: "urlServiceType.webshop" },
    { value: "socialmedia", label: "urlServiceType.socialmedia" },
    { value: "lastminute", label: "urlServiceType.lastminute" },
    { value: "virtualtour", label: "urlServiceType.virtualtour" },
];
exports.PriceDescriptionTypes = [
    { value: "Adults", label: "Volwassenen" },
    { value: "Children", label: "Kinderen" },
    { value: "Groups", label: "Groepen" },
    { value: "CJP", label: "CJP" },
    { value: "Pasholders", label: "Pashouders" },
    { value: "Lastminute", label: "Last-minute" },
];
exports.CountryCodes = [
    { value: "NL", label: "Nederland" },
    { value: "BE", label: "België" },
    { value: "DE", label: "Duitsland" },
];
exports.WfStatusOptions = [
    // {value: "draft", label: "Concept"},
    { value: "readyforvalidation", label: "Klaar voor validatie" },
    { value: "approved", label: "Goedgekeurd" },
    // {value: "rejected", label: "Afgekeurd"},
    { value: "deleted", label: "Verwijderd" },
    { value: "archived", label: "Gearchiveerd" },
];
//////////////////////////////////////////////
// END SUBITEM MODELS
//////////////////////////////////////////////
//# sourceMappingURL=Ndtrc.js.map